import React, { Children, useEffect, useState } from 'react'
import './website.css'
import { useParams } from "react-router-dom";
import { WebsiteAgendamentoService } from '../services/api/WebsiteAgendamento/WebsiteAgendamentoService';
import Page404 from '../Page404';
import md5 from 'blueimp-md5';
import { useCookies } from 'react-cookie';
import SalonTemplate from './Templates/Salon/SalonTemplate';

const TemplateAgendamento = ({ children }) => {


    const { dominio } = useParams();
    const [loading, setLoading] = useState(true)
    const [empresa, setEmpresa] = useState(null)
    const [activePage, setActivePage] = useState(true)
    const [enderecoC, setEnderecoC] = useState(null)
    const HASH_COOKIE = md5(dominio)
    const [cookies, setCookie, removeCookie] = useCookies([HASH_COOKIE], { doNotParse: true });
    const [isLogado, setIsLogado] = useState(false)
    const user = JSON.parse(localStorage.getItem('usc_hsp'))

    const formataEndereco = (empresa) => {

        let endereco = []
        let enderecoCompleto = []
        if (empresa?.logradouro != null && empresa?.logradouro != undefined) {

            endereco.push(empresa?.logradouro)
            if (empresa?.numero != null && empresa?.numero != undefined) {
                endereco.push(empresa?.numero)
            }
            if (empresa?.complemento != null && empresa?.complemento != undefined) {
                endereco.push(empresa?.complemento)
            }
        }
        endereco = endereco.join(', ')
        if (empresa?.bairro != null && empresa?.bairro != undefined) {
            enderecoCompleto.push(empresa?.bairro)
        }
        if (empresa?.cidade != null && empresa?.cidade != undefined) {
            enderecoCompleto.push(empresa?.cidade)
        }
        if (empresa?.ufs?.nome != null && empresa?.ufs?.nome != undefined) {
            enderecoCompleto.push(empresa?.ufs?.sigla)
        }
        enderecoCompleto = enderecoCompleto.join(' - ')

        setEnderecoC(endereco + ' ' + enderecoCompleto)

    }




    const verificaEmpresa = async (urlEmpresa) => {

        const data = await WebsiteAgendamentoService.verificaEmpresa(urlEmpresa);
        if (data.success) {
            if (data.data.habilitaAgenda == 0) {
                setActivePage(false)
                setLoading(false);
                return false;
            }

            setActivePage(true);
            let empresa = data.data?.empresas
            if (empresa != undefined) {
                localStorage.setItem("company", empresa.id);
                setEmpresa(empresa)
                formataEndereco(empresa)
            }
            setLoading(false);
        } else {
            setActivePage(false)

        }
        setLoading(false);
    }


    useEffect(() => {
        verificaEmpresa(dominio)
        console.log(cookies[HASH_COOKIE])
        if (cookies[HASH_COOKIE] != undefined) {
            setIsLogado(true)
        }
    }, [])


    if (!activePage) {
        return (<Page404 />)
    }

    return (
        <>

            <SalonTemplate
                dadosEmpresa={empresa}
                enderecoC={enderecoC}
            >
                {children}
            </SalonTemplate>


        </>)
}

export default TemplateAgendamento;